import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Group } from '../../models/group';
import { GroupService } from '../../services/group.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-groups-delete',
  templateUrl: './groups-delete.component.html',
  styleUrls: ['./groups-delete.component.css']
})
export class GroupsDeleteComponent implements OnInit {

  grp : Group;
  @Output() onDeleteValidation = new EventEmitter<boolean>();

  constructor(private service : GroupService,
              public activeModal : NgbActiveModal,
              private toast : ToastsManager,
              public translate : TranslateService) { }

  ngOnInit() {
  }

  onDeleteClick() {
    this.service.delete(this.grp.id).subscribe(() => {
      this.toast.success(this.translate.instant("toast.grpdeleted"), this.translate.instant("toast.success"));
      this.activeModal.close("close");
      this.onDeleteValidation.emit(true);
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/groups/groups-delete/groups-delete.component.ts